import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../../../enums/ajaxResult";
import { useApi } from "../../../../../useApi";

export function useSaveIsBankBox(boxId: number) {
    const { boxApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const saveIsBankBox = useCallback((isBankBox: boolean, onSuccess: () => void) => {
        setLoading(true);
        boxApi.setIsBankBox(boxId, isBankBox).then((r) => {
            if (r.result !== AjaxResult.Success) {
                enqueueSnackbar("Failed to save box bank tag!", { variant: "error" });
            } else {
                enqueueSnackbar("Box bank tag saved!", { variant: "success" });
                onSuccess();
            }
            setLoading(false);
        });
    }, [boxApi, boxId, enqueueSnackbar]);

    return { saveIsBankBox, loading }
}
